import React, { useState } from 'react';
import Tab from '.';

const CustomTabGroup = ({ active, setActive, data }) => {
  return (
    <section className="border-light-grey-2 p-0 mb-2 overflow-scroll">
      <table className="">
        <tr className="overflow-x-scroll">
          <div className="flex lg:items-center items-start lg:flex-row overflow-x-scroll">
            {data &&
              data.map(item => (
                <div
                  className={`${item.id !== 1 ? 'ml-5 w-44' : null}`}
                  key={item.id}
                >
                  <td>
                    <Tab
                      active={active === item.name.toLocaleLowerCase()}
                      onClick={() => setActive(item.name.toLocaleLowerCase())}
                      label={item.name}
                    />
                  </td>
                </div>
              ))}
          </div>
        </tr>
      </table>
    </section>
  );
};

export default CustomTabGroup;
